module.exports = __webpack_public_path__ + "static/img/5.8a7167a5.jpg";